const triggerSelector = '.blocks-gallery-item > figure > a';
let $lightboxEl;
let $window;
let $body;
let $document;
let windowAspectRatio;

function setWindowAspectRatio() {
  windowAspectRatio = $window.width() / $window.height();
}

function setLightboxSize() {
  if ($lightboxEl && $lightboxEl.length) {
    const $figureEl = $lightboxEl.find('figure');
    const aspectRatio = $figureEl.outerWidth() / $figureEl.outerHeight();
    let figureWidth = $window.width() - 30;
    if (aspectRatio < windowAspectRatio) {
      figureWidth = ($window.height() - 60) * aspectRatio;
    }
    $figureEl.css('width', `${parseInt(figureWidth, 10)}px`);
  }
}

function openLightbox(e) {
  e.preventDefault();
  const $triggerEl = $(this);
  $lightboxEl = $(`<div class="Overlay Overlay--show Overlay--lightbox"><div class="Lightbox"><figure><button class="Lightbox__close">Close</button><img src="${ $triggerEl.attr('href') }" alt="" /></figure></div></div>`).hide();
  const $captionEl = $triggerEl.closest('figure').find('figcaption');
  if ($captionEl.length) {
    $lightboxEl.find('figure').append($captionEl.clone());
  }
  $lightboxEl.on('click', clickLightbox);
  $lightboxEl.find('.Lightbox__close').on('click', closeLightbox);
  $lightboxEl.find('img').on('load', showLightbox);
  $lightboxEl.find('img').on('error', closeLightbox);
  $body.append($lightboxEl);
  $window.css('overflow', 'hidden');
  $body.css('overflow', 'hidden');
  $document.on('keyup', closeLightboxOnEsc);
}

function showLightbox() {
  $lightboxEl.fadeIn();
  setLightboxSize();
}

function clickLightbox(e) {
  if (!$(e.target).closest('figure').length) {
    closeLightbox();
  }
}

function closeLightboxOnEsc(e) {
  if(e.key === 'Escape') {
    closeLightbox();
  }
}

function closeLightbox() {
  if ($lightboxEl.length) {
    $lightboxEl.fadeOut(200);
    setTimeout(() => $lightboxEl.remove(), 200);
  }
  $window.css('overflow', 'initial');
  $body.css('overflow', 'initial');
  $document.off('keyup', closeLightboxOnEsc);
}

export default function() {
  $window = $(window);
  $body = $('body');
  $document = $(window.document);
  setWindowAspectRatio();
  $window.on('resize', setWindowAspectRatio);
  $window.on('resize', setLightboxSize);
  $(window.document).on('click', triggerSelector, openLightbox);
}



// WEBPACK FOOTER //
// ./scripts/components/lightbox.js